import { render, staticRenderFns } from "./StoreService.vue?vue&type=template&id=16c83dee&scoped=true"
import script from "./StoreService.vue?vue&type=script&lang=js"
export * from "./StoreService.vue?vue&type=script&lang=js"
import style0 from "./StoreService.vue?vue&type=style&index=0&id=16c83dee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c83dee",
  null
  
)

export default component.exports